import React from 'react';
import { View, StyleSheet, Image, Text } from 'react-native';

import colors from 'shared/modules/common/constants/colors';
import typography from 'shared/modules/common/constants/typography';
import { formatToCurrency } from 'shared/utils/japanese';

export default function AppleTradeInBanner({
  price,
  purchasedAt,
}: {
  price: number;
  purchasedAt: string;
}) {
  return (
    <View style={styles.bannerContainer}>
      <View style={styles.headerImageContainer}>
        <Image
          source={require('shared/assets/images/illustration-support@3x.png')}
          style={styles.headerImage}
        />
      </View>

      <View>
        <Text style={styles.paragraph}>
          この金額は、最終的な下取り額と、購入時にAppleから提供された元の下取り額との差額を反映しています。
        </Text>
        <Text style={styles.paragraph}>
          下取りに関するご質問やご不明な点は、Appleのカスタマーサポート
          0120-993-993 までお電話でお問い合わせください。
        </Text>
        {!price || !purchasedAt ? null : (
          <Text style={styles.paragraph}>
            {price && (
              <Text style={styles.paragraph}>
                購入時の下取り額: {formatToCurrency(price)} {`\n`}{' '}
              </Text>
            )}
            {purchasedAt && (
              <Text style={styles.paragraph}>
                購入日:
                {purchasedAt}
              </Text>
            )}
          </Text>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  headerImageContainer: {
    marginBottom: 24,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  headerImage: {
    width: 88,
    height: 56,
  },
  bannerContainer: {
    backgroundColor: colors.greySuperLight,
    borderRadius: 16,
    paddingHorizontal: 32,
    paddingTop: 32,
    paddingBottom: 24,
    marginTop: 32,
  },
  paragraph: {
    ...typography.caption02,
    marginBottom: 16,
    fontSize: 13,
    fontWeight: '400',
    lineHeight: 16,
    textAlign: 'center',
    color: colors.blackMedium,
  },
});
